import React from 'react';
import { VelaBrief } from '../data';

const STRIP: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '10px 14px',
  background: '#FAF9FD',
  border: '1px solid #ECE7F7',
  borderRadius: 10,
  marginBottom: 14,
};

const MONO: React.CSSProperties = {
  width: 22,
  height: 22,
  background: 'linear-gradient(135deg, #6B46C1 0%, #8B5CF6 100%)',
  borderRadius: 6,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

const MSG: React.CSSProperties = {
  flex: 1,
  fontSize: 12.5,
  color: '#0E1A1A',
  lineHeight: 1.5,
};

const ACT: React.CSSProperties = {
  background: 'transparent',
  border: 0,
  fontSize: 12,
  fontWeight: 600,
  color: '#0F6E56',
  cursor: 'pointer',
  padding: '2px 4px',
  whiteSpace: 'nowrap',
};

type Props = { brief: VelaBrief };

export default function VelaBriefCard({ brief }: Props) {
  return (
    <div style={STRIP}>
      <div style={MONO}>
        <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true">
          <path d="M4 3 L10 20 L14 20 L20 3 L16 3 L12 15 L8 3 Z" fill="#FFFFFF" />
        </svg>
      </div>
      <div style={MSG}>{brief.message}</div>
      <button type="button" style={ACT}>
        {brief.cta} {'\u2192'}
      </button>
    </div>
  );
}